import { render, staticRenderFns } from "./IframePopup.vue?vue&type=template&id=2d56741a&scoped=true&"
import script from "./IframePopup.vue?vue&type=script&lang=js&"
export * from "./IframePopup.vue?vue&type=script&lang=js&"
import style0 from "./IframePopup.vue?vue&type=style&index=0&id=2d56741a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d56741a",
  null
  
)

export default component.exports